<template>
  <ItemWrapper @openChildEditor="handleOpenChildEditor" :showSortIcon="true">
    <div class="form-item-itemKey">
      <component
        v-model="internalValue"
        :ref="itemKey"
        :is="componentType"
        :isPc="!isMobile"
        :title="title"
        :option="optionList"
        :link="agreementLink"
        :isMultiple="isMultiple"
        :isRequired="isRequired"
        :isDisabled="isEditMode || disabled"
      >
      </component>
    </div>
  </ItemWrapper>
</template>

<script>
import _ from 'lodash'
import { childName } from '../index'
import { mapGetters } from 'vuex'
import { FORM_ITEM_TYPE_LIST, HAS_OPTION_FORM_ITEM_TYPE } from '@/constant/crm'
import ItemWrapper from '../../../components/render/itemWrapper.vue'
import DateItem from '../components/date.vue'
import LinkItem from '../components/link.vue'
import TextItem from '../components/text.vue'
import LocationItem from '../components/location.vue'
import SelectItem from '../components/select.vue'
import UploadItem from '../components/upload.vue'

export default {
  components: {
    ItemWrapper,
    DateItem,
    LinkItem,
    LocationItem,
    SelectItem,
    UploadItem,
    TextItem
  },
  props: {
    value: {},
    title: {
      type: String,
      default: ''
    },
    itemKey: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    order: {
      type: Number,
      default: 0
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    options: {
      type: String,
      default: ''
    },
    linkSetting: {
      type: Object
    },
    styleConfig: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      photoLoaded: false,
      componentsMapping: {
        [FORM_ITEM_TYPE_LIST.TEXT.value]: TextItem,
        [FORM_ITEM_TYPE_LIST.DATE.value]: DateItem,
        [FORM_ITEM_TYPE_LIST.SINGLE.value]: SelectItem,
        [FORM_ITEM_TYPE_LIST.MULTIPLE.value]: SelectItem,
        [FORM_ITEM_TYPE_LIST.LINK.value]: LinkItem,
        [FORM_ITEM_TYPE_LIST.LOCATION.value]: LocationItem,
        [FORM_ITEM_TYPE_LIST.ATTACHMENT.value]: UploadItem
      },
      internalValue: ''
    }
  },
  computed: {
    ...mapGetters('microSite', ['isEditMode', 'currentPage', 'isMobile', 'pagePathPrefix']),
    componentType () {
      if (this.componentsMapping[this.type]) {
        return this.componentsMapping[this.type]
      }
      return TextItem
    },
    optionList () {
      let option = []
      const newVIds = []
      if (HAS_OPTION_FORM_ITEM_TYPE.includes(this.type) && this.options) {
        option = _.filter((this.options || '').split('\n')).map((item, index) => {
          const vid = `${index}_${item}`
          newVIds.push(vid)
          return {
            _vid: vid,
            index: index,
            label: item,
            value: item
          }
        })
      }
      return option
    },
    agreementLink () {
      if (this.linkSetting) {
        if (this.linkSetting.isUpload) {
          const file = this.linkSetting.upload
          if (file.fileUrl && file.fileName) {
            return `${file.fileUrl}?filename=${file.fileName}`
          }
          return ''
        }
        return this.linkSetting.url
      }
      return ''
    },
    isMultiple () {
      return this.type === FORM_ITEM_TYPE_LIST.MULTIPLE.value
    }
  },
  created () {
    this.internalValue = this.value
  },
  methods: {
    handleOpenChildEditor () {
      this.$emit('openChildEditor', {
        editorName: childName,
        fromChild: true
      })
    }
  },
  mounted () {
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
